module.exports = __webpack_public_path__ + "img/image (1).50b815f7.jpeg";